import React, { useState } from "react";
import { CircularProgress, Box, Dialog, Typography } from "@material-ui/core";
import PhoneIcon from '@material-ui/icons/Phone';

import dialogStyles from "../../pages/callpanel/components/Transfer/styles";
import CallInQueue from "./CallInQueue";
import useStyles from "../Header/styles";

export default function CallsInQueue(props) {
	var [queueDetailsFlag, setQueueFlag] = useState(false);
	const showQueueDetails = (value) => {
		setQueueFlag(value)
	};
	var classesDialog = dialogStyles();
	var classes = useStyles();
	return (
		<div style={{position:"relative", cursor: "pointer"}} title="Queue Call">
			<PhoneIcon classes={{ root: classes.headerIcon }} style={{transform:"rotate(135deg)"}}  onClick={() => showQueueDetails(true)}/>
			<Box className={classes.queueCountCircleParent}  onClick={() => showQueueDetails(true)}>
				<CircularProgress variant="determinate" color={props.value > 0 ? "secondary" : "primary"} value={100} size="1.1rem" className={classes.queueCountCircleProgree} />
				<Box top={2} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
					<Typography variant="caption" component="div" weight="medium" className={classes.queueCountNum}>
						{props.value}
					</Typography>
				</Box>
			</Box>
			<Dialog keepMounted={true} aria-labelledby="customized-dialog-title" open={queueDetailsFlag} className={classesDialog.DialogBox} maxWidth="md">
				<CallInQueue showQueueDetails={showQueueDetails}/>
			</Dialog>
		</div>
	);
}
